import React, {Component} from "react";
import {List} from "antd";
import {FormattedMessage} from "react-intl";

const ListItem = List.Item;
const ListItemMeta = ListItem.Meta;

class DealersListItem extends Component {

  handleOnClick = () => {
    const {item: connectedId} = this.props;
    this.props.dispatchSaveParamsInformation(connectedId);
  }

  render = () => {
    const {item, dealer} = this.props;

    return (
      <ListItem key={item.connectedId} style={{
        border: '1px solid',
        borderRadius: '4px',
        paddingRight: '24px',
        paddingLeft: '24px',
        marginTop: '2px',
        marginBottom: '2px',
        borderColor: dealer && dealer.id === item.id ? '#1C69D4' : '#d9d9d9'
      }} onClick={this.handleOnClick}>
        <ListItemMeta
          title={item.dealerName}
          description={`${item.address.street1}, ${item.address.city}, ${item.address.zipcode}, ${item.address.country}`}/>
        <div className="d-flex justify-content-between">
          {item.supportedBrands.map(brand => {
            return (
              <React.Fragment>
                <FormattedMessage id={`intervention.brand.${brand}`}/>
                &nbsp;
              </React.Fragment>
            )
          })}
        </div>
      </ListItem>);
  }
}

export default DealersListItem;



// WEBPACK FOOTER //
// ./src/components/call-center/dealer/DealersListItem.js